var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-form",
    { ref: "editForm" },
    [
      _vm.isOld
        ? _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm revisionLayout",
              attrs: { title: "LBLREV", topClass: "topcolor-orange" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: _vm.editable && _vm.isRevision,
                        editable: _vm.editable && _vm.isRevision,
                        label: "LBLREVNO",
                        name: "revisionNum",
                      },
                      model: {
                        value: _vm.facility.revisionNum,
                        callback: function ($$v) {
                          _vm.$set(_vm.facility, "revisionNum", $$v)
                        },
                        expression: "facility.revisionNum",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: false,
                        label: "LBLREVPERIOD",
                        name: "regDtStr",
                      },
                      model: {
                        value: _vm.facility.regDtStr,
                        callback: function ($$v) {
                          _vm.$set(_vm.facility, "regDtStr", $$v)
                        },
                        expression: "facility.regDtStr",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: false,
                        label: "LBLREVUSER",
                        name: "regUserName",
                      },
                      model: {
                        value: _vm.facility.regUserName,
                        callback: function ($$v) {
                          _vm.$set(_vm.facility, "regUserName", $$v)
                        },
                        expression: "facility.regUserName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-4" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: _vm.editable && _vm.isRevision,
                        editable: _vm.editable && _vm.isRevision,
                        label: "LBLREVREASON",
                        name: "revisionContent",
                      },
                      model: {
                        value: _vm.facility.revisionContent,
                        callback: function ($$v) {
                          _vm.$set(_vm.facility, "revisionContent", $$v)
                        },
                        expression: "facility.revisionContent",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
      _c(
        "c-card",
        { staticClass: "cardClassDetailForm", attrs: { title: "LBLDETAIL" } },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.isOld &&
                          !_vm.isRevision,
                        expression:
                          "editable &&!disabled && isOld && !isRevision",
                      },
                    ],
                    attrs: { label: "LBLREV", icon: "restart_alt" },
                    on: { btnClicked: _vm.setRevision },
                  }),
                  _c("c-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.isOld &&
                          _vm.isRevision,
                        expression:
                          "editable &&!disabled && isOld && isRevision",
                      },
                    ],
                    attrs: { label: "LBLREVCANCEL", icon: "restart_alt" },
                    on: { btnClicked: _vm.cancelRevision },
                  }),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.facility,
                          mappingType: _vm.mappingType,
                          label: "LBLSAVEALL",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.save,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "card-select" },
            [
              _vm.isOld
                ? _c("c-select", {
                    attrs: {
                      editable: !_vm.isRevision,
                      comboItems: _vm.revisionData,
                      type: "custom",
                      typetext: "개정이력",
                      itemText: "revisionNum",
                      itemValue: "facilityCd",
                      name: "selectedFacilityCd",
                      label: "",
                    },
                    on: { input: _vm.rowClickRev },
                    model: {
                      value: _vm.selectedFacilityCd,
                      callback: function ($$v) {
                        _vm.selectedFacilityCd = $$v
                      },
                      expression: "selectedFacilityCd",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    required: true,
                    label: "시설명(차량번호)",
                    name: "facilityName",
                  },
                  model: {
                    value: _vm.facility.facilityName,
                    callback: function ($$v) {
                      _vm.$set(_vm.facility, "facilityName", $$v)
                    },
                    expression: "facility.facilityName",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-text", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    required: true,
                    label: "시설관리번호",
                    name: "facilityNo",
                  },
                  model: {
                    value: _vm.facility.facilityNo,
                    callback: function ($$v) {
                      _vm.$set(_vm.facility, "facilityNo", $$v)
                    },
                    expression: "facility.facilityNo",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    codeGroupCd: "HCF_FACILITY_TYPE_CD",
                    required: true,
                    type: "edit",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "hcfFacilityTypeCd",
                    label: "시설유형",
                  },
                  on: { datachange: _vm.facilityTypeChange },
                  model: {
                    value: _vm.facility.hcfFacilityTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.facility, "hcfFacilityTypeCd", $$v)
                    },
                    expression: "facility.hcfFacilityTypeCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-process", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    multiple: "multiple",
                    label: "단위공정",
                    name: "processCd",
                  },
                  model: {
                    value: _vm.facility.processCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.facility, "processCd", $$v)
                    },
                    expression: "facility.processCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: {
                    disabled: _vm.disabled,
                    required: true,
                    editable: _vm.editable,
                    type: "edit",
                    name: "plantCd",
                  },
                  model: {
                    value: _vm.facility.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.facility, "plantCd", $$v)
                    },
                    expression: "facility.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-radio", {
                  attrs: {
                    disabled: _vm.disabled,
                    editable: _vm.editable,
                    comboItems: _vm.useFlagItems,
                    label: "LBLUSEFLAG",
                    name: "useFlag",
                  },
                  model: {
                    value: _vm.facility.useFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.facility, "useFlag", $$v)
                    },
                    expression: "facility.useFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm q-mt-sm",
          attrs: { title: "유형별 상세" },
        },
        [
          _c(
            "template",
            { slot: "card-description" },
            [
              _c(
                "font",
                {
                  staticClass: "text-negative",
                  staticStyle: { "font-size": "0.8em", "font-weight": "300" },
                },
                [
                  _vm._v(
                    " (※ 시설유형에 따라 시설 상세정보를 입력하는 영역입니다.) "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "card-detail" },
            [
              _vm.facilityType1
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            required: true,
                            label: "설치장소",
                            name: "installationPlace",
                          },
                          model: {
                            value: _vm.facility.installationPlace,
                            callback: function ($$v) {
                              _vm.$set(_vm.facility, "installationPlace", $$v)
                            },
                            expression: "facility.installationPlace",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _vm.facilityType1_1
                          ? _c("c-text", {
                              attrs: {
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                type: "number",
                                label: "연간취급량(톤/년)",
                                name: "annualHandling",
                              },
                              model: {
                                value: _vm.facility.annualHandling,
                                callback: function ($$v) {
                                  _vm.$set(_vm.facility, "annualHandling", $$v)
                                },
                                expression: "facility.annualHandling",
                              },
                            })
                          : _vm._e(),
                        _vm.facilityType1_2
                          ? _c("c-text", {
                              attrs: {
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                type: "number",
                                label: "시설용량(㎥)",
                                name: "facilityCapacity",
                              },
                              model: {
                                value: _vm.facility.facilityCapacity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.facility,
                                    "facilityCapacity",
                                    $$v
                                  )
                                },
                                expression: "facility.facilityCapacity",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "설치일",
                            name: "installationDate",
                          },
                          model: {
                            value: _vm.facility.installationDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.facility, "installationDate", $$v)
                            },
                            expression: "facility.installationDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "방재설비",
                            name: "disasterPreventionEquipment",
                          },
                          model: {
                            value: _vm.facility.disasterPreventionEquipment,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.facility,
                                "disasterPreventionEquipment",
                                $$v
                              )
                            },
                            expression: "facility.disasterPreventionEquipment",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "비고",
                            name: "remarks",
                          },
                          model: {
                            value: _vm.facility.remarks,
                            callback: function ($$v) {
                              _vm.$set(_vm.facility, "remarks", $$v)
                            },
                            expression: "facility.remarks",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.facilityType2
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _vm.facilityType2_1
                          ? _c("c-text", {
                              attrs: {
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                required: true,
                                label: "운송방식",
                                name: "modeOfTransport",
                              },
                              model: {
                                value: _vm.facility.modeOfTransport,
                                callback: function ($$v) {
                                  _vm.$set(_vm.facility, "modeOfTransport", $$v)
                                },
                                expression: "facility.modeOfTransport",
                              },
                            })
                          : _vm._e(),
                        _vm.facilityType2_2
                          ? _c("c-text", {
                              attrs: {
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                required: true,
                                label: "운반방식",
                                name: "transportMethod",
                              },
                              model: {
                                value: _vm.facility.transportMethod,
                                callback: function ($$v) {
                                  _vm.$set(_vm.facility, "transportMethod", $$v)
                                },
                                expression: "facility.transportMethod",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _vm.facilityType2_1
                          ? _c("c-text", {
                              attrs: {
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                type: "number",
                                label: "탱크 사양(재질 및 용량(㎥, ton)등)",
                                name: "tankSpecifications",
                              },
                              model: {
                                value: _vm.facility.tankSpecifications,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.facility,
                                    "tankSpecifications",
                                    $$v
                                  )
                                },
                                expression: "facility.tankSpecifications",
                              },
                            })
                          : _vm._e(),
                        _vm.facilityType2_2
                          ? _c("c-text", {
                              attrs: {
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                type: "number",
                                label: "운반용량(㎥, ton)",
                                name: "carryingCapacity",
                              },
                              model: {
                                value: _vm.facility.carryingCapacity,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.facility,
                                    "carryingCapacity",
                                    $$v
                                  )
                                },
                                expression: "facility.carryingCapacity",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.facilityType3
                ? [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            type: "number",
                            label: "거리(km)",
                            name: "distance",
                          },
                          model: {
                            value: _vm.facility.distance,
                            callback: function ($$v) {
                              _vm.$set(_vm.facility, "distance", $$v)
                            },
                            expression: "facility.distance",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            label: "배관재질",
                            name: "pipeMaterial",
                          },
                          model: {
                            value: _vm.facility.pipeMaterial,
                            callback: function ($$v) {
                              _vm.$set(_vm.facility, "pipeMaterial", $$v)
                            },
                            expression: "facility.pipeMaterial",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }